import Layout from "@/components/feature/Layout";
import HeroBanner from "./components/HeroBanner";
import CategoryNav from "./components/CategoryNav";
import HotRanking from "./components/HotRanking";
import LatestRelease from "./components/LatestRelease";
import ArticleList from "./components/ArticleList";
import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    document.title = "爱看影院 | 免费电影大全与免费电视剧全集 | 影视大全免费在线观看不卡顿";
  }, []);

  return (
    <Layout>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "爱看影院",
            url: "https://aikan.com/",
            description:
              "爱看影院影视大全免费在线观看，免费电影、免费电视剧、热播综艺一网打尽，海量高清资源不缓冲流畅播放。",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://aikan.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "爱看影院",
            url: "https://aikan.com/",
            description:
              "爱看影院 - 免费电影、免费电视剧、热播综艺、热门动漫一网打尽的影视大全平台。",
            sameAs: [
              "https://weibo.com/aikanyingyuan",
              "https://space.bilibili.com/aikanyingyuan",
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "爱看影院首页",
            description:
              "爱看影院影视大全免费在线观看，免费电影、免费电视剧、热播综艺一网打尽。",
            url: "https://aikan.com/",
            isPartOf: { "@id": "https://aikan.com/#website" },
          }),
        }}
      />

      <HeroBanner />
      <CategoryNav />
      <HotRanking />
      <LatestRelease />
      <ArticleList />
    </Layout>
  );
}